/** FROZEN (W0-contracts). Agents owns these implementations, current authority, and fleet coverage. */
import { lazy, Suspense, type ComponentType, type ReactElement } from 'react';
import type { HyloServices, Id, Live } from '@/model';
import { agentRuntime } from './data';
import { AgentScope } from './components';
const AssistantIntro = lazy(() => import('./fleet').then(m => ({ default: m.AssistantIntro })));
const ApprovalInbox = lazy(() => import('./approvals').then(m => ({ default: m.ApprovalInbox })));
import {ChatAgentsLink} from './extensions';
const MountManager = lazy(() => import('./policy').then(m => ({ default: m.MountManager })));
export function AssistantIntroCard(): ReactElement | null { return <AgentScope><Suspense fallback={null}><AssistantIntro /></Suspense></AgentScope>; }
export interface AssistantApprovalInboxProps {
    limit?: number;
}
export function AssistantApprovalInbox(props: AssistantApprovalInboxProps): ReactElement | null { return <AgentScope><Suspense fallback={null}><ApprovalInbox {...props}/></Suspense></AgentScope>; }
export interface ChatAgentsEntryProps {
    conversationId: Id;
}
export function ChatAgentsEntry(props: ChatAgentsEntryProps): ReactElement | null { return <AgentScope><Suspense fallback={null}><ChatAgentsLink {...props}/></Suspense></AgentScope>; }
export interface AgentMountPickerProps {
    projectId: Id;
    onDone(): void;
    onCancel(): void;
}
/** Agents performs the authorized mount, rather than returning unrestricted account IDs. */
export function AgentMountPicker(props: AgentMountPickerProps): ReactElement | null { return <AgentScope><Suspense fallback={null}><MountManager {...props}/></Suspense></AgentScope>; }
export interface HomeAssistantAttention {
    pendingCount: number;
    coverage: 'unknown' | 'loading' | 'complete' | 'partial' | 'failed';
    protectedHomeIds: readonly Id[];
}
/** Stable per service/login scope; retired data is cleared synchronously by the runtime. */
export function homeAssistantAttention(services: HyloServices): Live<HomeAssistantAttention> {
    return agentRuntime(services).attentionLive();
}
export interface ProposalReviewTarget {
    proposalId: Id;
    assistantId: Id;
    revision: number;
    action: Readonly<Record<string, unknown>>;
    actionFingerprint: string;
}
export type ProposalReviewState = {
    phase: 'unsupported' | 'loading';
} | {
    phase: 'error';
    message: string;
} | {
    phase: 'ready';
    proposalId: Id;
    revision: number;
    actionFingerprint: string;
    mutationEpoch?: Id;
};
export interface ProposalReviewProps {
    target: ProposalReviewTarget;
    onState(state: ProposalReviewState): void;
}
const reviewers = new Map<string, ComponentType<ProposalReviewProps>>();
/** One renderer per exact action kind. Never executes approval; Agents rechecks captured readiness. */
export function registerProposalReviewer(kind: string, component: ComponentType<ProposalReviewProps>): void {
    reviewers.set(kind, component);
}
export function proposalReviewer(kind: string): ComponentType<ProposalReviewProps> | undefined { return reviewers.get(kind); }
